var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 2C2.5 1.44772 2.94772 1 3.5 1H20.5C21.0523 1 21.5 1.44772 21.5 2C21.5 2.55228 21.0523 3 20.5 3H3.5C2.94772 3 2.5 2.55228 2.5 2Z",
    fill: "#141415"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 22C2.5 21.4477 2.94772 21 3.5 21H20.5C21.0523 21 21.5 21.4477 21.5 22C21.5 22.5523 21.0523 23 20.5 23H3.5C2.94772 23 2.5 22.5523 2.5 22Z",
    fill: "#141415"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73728 21H17.2625C16.6478 18.3333 15.895 16.3677 15.0366 15.0471C14.0707 13.5611 13.0543 13.001 11.9991 13C10.9448 12.999 9.92918 13.5572 8.96346 15.0429C8.10501 16.3636 7.35205 18.3306 6.73728 21ZM7.28657 13.9529C8.48751 12.1053 10.0552 10.9982 12.0009 11C13.9457 11.0018 15.5127 12.1098 16.7134 13.9571C17.8981 15.7796 18.8041 18.4231 19.4806 21.8038C19.5394 22.0976 19.4633 22.4023 19.2734 22.634C19.0834 22.8657 18.7996 23 18.5 23H5.50001C5.20043 23 4.91663 22.8657 4.72669 22.634C4.53675 22.4024 4.46068 22.0977 4.51941 21.804C5.19581 18.4206 6.10187 15.7755 7.28657 13.9529Z",
    fill: "#141415"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72664 1.36604C4.91658 1.13434 5.2004 1 5.50001 1H18.5C18.7996 1 19.0834 1.13431 19.2733 1.36598C19.4633 1.59765 19.5393 1.90227 19.4806 2.19604C18.8042 5.57939 17.8981 8.22446 16.7134 10.0471C15.5125 11.8947 13.9448 13.0018 11.9991 13C10.0543 12.9982 8.48734 11.8902 7.28657 10.0429C6.10196 8.22042 5.19587 5.57688 4.51944 2.1962C4.46066 1.90241 4.5367 1.59775 4.72664 1.36604ZM6.73751 3C7.3522 5.66669 8.10506 7.63231 8.96346 8.95292C9.92935 10.4389 10.9457 10.999 12.0009 11C13.0552 11.001 14.0708 10.4428 15.0366 8.95711C15.895 7.63641 16.648 5.66945 17.2627 3H6.73751Z",
    fill: "#141415"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 7.5C9.5 6.94772 9.94772 6.5 10.5 6.5H13.5C14.0523 6.5 14.5 6.94772 14.5 7.5C14.5 8.05228 14.0523 8.5 13.5 8.5H10.5C9.94772 8.5 9.5 8.05228 9.5 7.5Z",
    fill: "#141415"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 19C8.5 18.4477 8.94772 18 9.5 18H14.5C15.0523 18 15.5 18.4477 15.5 19C15.5 19.5523 15.0523 20 14.5 20H9.5C8.94772 20 8.5 19.5523 8.5 19Z",
    fill: "#141415"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeHourglass);
export default __webpack_public_path__ + "static/media/time-hourglass.84c5e68b4506e82986ad172b04912585.svg";
export { ForwardRef as ReactComponent };